import React, { useState } from 'react'
import BlogContent from './BlogContent'
import BlogRelatedPost from './BlogRelatedPost'
import Subheader from '../../component/Subheader';
import { useParams } from "react-router-dom"
import GlobalFaq from '../../component/GlobalFaq';

export default function BlogDetail({ initialData, initialFaq }) {
  const { blog_slug } = useParams();
  const [blogTitle, setBlogTitle] = useState("");
  const subheadData = {
    heading: 'Blog Detail',
    breadcrumb: [
      {
        slug: "/blog",
        name: "Blog",
      },
      {
        slug: `/blog/${blog_slug}`,
        name: blogTitle ? blogTitle.slice(0, 18) + "..." : "",
      }
    ]
  }

  return (
    <>
      <Subheader subheadData={subheadData} />
      <BlogContent initialData={initialData?.detailpage} setBlogTitle={setBlogTitle} />
      <GlobalFaq initialData={initialFaq}/>
      <BlogRelatedPost initialData={initialData?.listpage} />
    </>
  )
}
